import { render, staticRenderFns } from "./fila_telemedicina.vue?vue&type=template&id=9b749536"
import script from "./fila_telemedicina.vue?vue&type=script&lang=js"
export * from "./fila_telemedicina.vue?vue&type=script&lang=js"
import style0 from "./fila_telemedicina.vue?vue&type=style&index=0&id=9b749536&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports